module.exports = __webpack_public_path__ + "static/img/56aeb7988d2896168f0cba0655099fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/usb_box.png
// module id = owTZ
// module chunks = 1